import { useCallback, useMemo } from 'react'
import styled from 'styled-components'

import RightPanelEmptyState from '../components/RightPanelEmptyState'
import { hasRenderableTimelineContent } from '../components/tripPlanCanvasContent'
import ItineraryContainer from '../containers/ItineraryContainer'
import { useItineraryContext } from '../contexts/ItineraryContext'
import { useTripPlannerEventBus } from 'tripPlanner/assistant/contexts/TripPlannerEventBus'
import { EmptyStateWrapper } from '../styles/layoutStyles'
import { mobileTimelineCanvasVars } from './mobileTimelineCanvas.styles'
import { useTripChatMobileAppShell } from './TripChatMobileAppShell'
import { useTripChatMobileOverlay } from './TripChatMobileOverlayContext'

const TimelineRoot = styled.div`
  ${mobileTimelineCanvasVars}

  height: 100%;
  min-height: 0;
  overflow: hidden;
  background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
`

function TripChatMobileTimelineView() {
  const { activeTab } = useTripChatMobileAppShell()
  const eventBus = useTripPlannerEventBus()
  const { drawerCloseRequest, openOverlay, closeOverlay } = useTripChatMobileOverlay()
  const { itineraryData } = useItineraryContext()
  const isTimelineActive = activeTab === 'timeline'
  const hasTimelineContent = useMemo(
    () => hasRenderableTimelineContent(itineraryData),
    [itineraryData],
  )
  const handleAskAIAction = useCallback(() => {
    eventBus.dispatch({ type: 'focus_floating_ask_ai' })
  }, [eventBus])
  const handleItineraryDrawerOpenChange = useCallback((isOpen: boolean) => {
    if (isOpen) {
      openOverlay('drawer')
      return
    }

    closeOverlay('drawer')
  }, [closeOverlay, openOverlay])

  if (!hasTimelineContent) {
    return (
      <EmptyStateWrapper padding={24}>
        <RightPanelEmptyState variant="timeline" />
      </EmptyStateWrapper>
    )
  }

  return (
    <TimelineRoot data-testid="trip-chat-mobile-timeline-view">
      <ItineraryContainer
        visible={isTimelineActive}
        selectedDayItineraryId={undefined}
        selectedStop={undefined}
        surface="mobile"
        onAskAIAction={handleAskAIAction}
        drawerCloseSignal={drawerCloseRequest}
        onDrawerOpenChange={handleItineraryDrawerOpenChange}
      />
    </TimelineRoot>
  )
}

export default TripChatMobileTimelineView
